export default __webpack_public_path__ + "static/glass-spinning-weel-optimised-79f7699910439de1dacc0e81dc6c0155.gif";